import axios from 'axios';
import {setToken,getToken,removeToken} from "./authToken"
import configData from './dashboardDara.json';

export default async function(path, data, method) {
  const token = getToken();

  let config = {
    method: method,
    maxBodyLength: Infinity,
    url: `${configData.url}/app/${path}`,
    contentType: "multipart/form-data",
    headers: {
      'authorization': token || "",
      'Content-Type': 'multipart/form-data',
    },
    data: data
  };

  return axios.request(config)
    .then((response) => {
      console.log("✅ res:", response);
      return response;
    })
    .catch((error) => {
      console.log("❌ Axios Error:", error);
      return error.response || { status: 500, data: "Server error" };
    });
}
